<template>
  <nav class="main-menu scf-row">
    <div class="main-menu--inner scf-row__inner">
      <h1 class="home-page">
        <button
          class="button--transparent scf-heading-s"
          :class="
            $store.state.targetComponent === 'home' ? 'main-menu--selected' : ''
          "
          @click="$store.state.targetComponent = 'home'"
        >
          {{ author }}
        </button>
      </h1>
      <ul class="menu-list">
        <li
          v-for="menuItem in $store.state.mainMenuItems"
          :key="menuItem.id"
          class="menu-item"
        >
          <button
            class="button--transparent scf-body-m"
            :class="
              $store.state.targetComponent === menuItem
                ? 'main-menu--selected'
                : ''
            "
            @click="$store.state.targetComponent = menuItem"
          >
            {{ menuItem }}
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MainMenu",
  props: {
    author: String,
  },
};
</script>

<style lang="less" scoped>
@import "../styles/all.less";

.main-menu {
  background-color: @base-dark-80;
  border-bottom: 1px solid @white-40;
  position: sticky;
  top: 0;
  z-index: @max-z-index-page - 1;
  &:hover {
    background-color: @base-dark;
    border-color: @white;
  }
}
.main-menu--inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: @scf-space-2xs;
  padding-bottom: @scf-space-2xs;

  @media @scf-breakpoints--m {
    flex-direction: row;
  }

  .menu {
    //border: 1px solid red;
    display: flex;
    justify-content: space-between;
    width: auto;
  }
  .home-page {
    align-self: center;
    flex: 1;
  }

  .main-menu--selected {
    color: @accent;
  }

  ul.menu-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    list-style: none;

    @media @scf-breakpoints--m {
      justify-content: flex-end;
    }

    li.menu-item {
      position: relative;
      padding: 10px 20px;
    }
  }
}
</style>
